import { Link } from "react-router-dom";
import Logo from "@/components/brand/Logo";
import Footer from "@/components/brand/Footer";
import { useAuth, dashboardPathForRole } from "@/context/AuthContext";

export default function PageShell({ children, showAuthActions = true }) {
    const { user, status, signOut } = useAuth();

    async function handleSignOut() {
        // React 19 + react-router-dom v7 dispatches navigate() inside a
        // low-priority startTransition. If we let signOut()'s urgent
        // setState('no') land first, ProtectedRoute intercepts the still-
        // matched protected route and Navigates to /login before the
        // transition to '/' commits. Doing a hard navigation for sign-out
        // sidesteps the race entirely and gives the user a clean slate.
        await signOut();
        window.location.replace("/");
    }

    return (
        <div className="min-h-screen flex flex-col" style={{ background: "var(--st-white)" }}>
            <header
                className="border-b"
                style={{ borderColor: "var(--st-line)", background: "var(--st-white)" }}
                data-testid="site-header"
            >
                <div className="max-w-6xl mx-auto px-4 sm:px-6 h-20 flex items-center justify-between gap-3">
                    {/* Mobile: compact lockup (h≈32, w≈139). Desktop: full lockup. */}
                    <div className="sm:hidden shrink-0" data-testid="header-logo-mobile">
                        <Logo compact />
                    </div>
                    <div className="hidden sm:block shrink-0" data-testid="header-logo-desktop">
                        <Logo />
                    </div>
                    {showAuthActions && (
                        <nav className="flex items-center gap-2 sm:gap-3 shrink-0" data-testid="header-nav">
                            {status === "yes" && user ? (
                                <>
                                    {user.role === "student" && (
                                        <Link
                                            to="/live"
                                            className="btn-ghost text-sm hidden sm:inline-flex"
                                            data-testid="header-live-sessions-link"
                                        >
                                            Live Sessions
                                        </Link>
                                    )}
                                    <Link
                                        to={dashboardPathForRole(user.role)}
                                        className="btn-ghost text-sm"
                                        data-testid="header-dashboard-link"
                                    >
                                        My dashboard
                                    </Link>
                                    <button
                                        type="button"
                                        className="btn-outline-navy text-sm"
                                        onClick={handleSignOut}
                                        data-testid="header-signout-btn"
                                    >
                                        Sign out
                                    </button>
                                </>
                            ) : (
                                <>
                                    <Link to="/login" className="btn-ghost text-sm" data-testid="header-login-link">
                                        Sign in
                                    </Link>
                                    <Link to="/signup" className="btn-royal text-sm" data-testid="header-signup-link">
                                        Enroll
                                    </Link>
                                </>
                            )}
                        </nav>
                    )}
                </div>
            </header>

            <main className="flex-1">{children}</main>
            <Footer />
        </div>
    );
}
